export const extractContractLoadErrorMessage = (error) => (
  error?.response?.data?.error?.message
  || error?.response?.data?.message
  || error?.message
  || ''
);
